// extracted by mini-css-extract-plugin
export var cardFooter = "GenericReviewSection-module--cardFooter--66e61";
export var cardStyles = "GenericReviewSection-module--cardStyles--86d29";
export var dateStyle = "GenericReviewSection-module--dateStyle--35dda";
export var headerSection = "GenericReviewSection-module--headerSection--4e618";
export var logoGlassDoor = "GenericReviewSection-module--logoGlassDoor--bb496";
export var rhglassdoorreview = "GenericReviewSection-module--rhglassdoorreview--c0c4e";